import { createStore, compose, applyMiddleware } from 'redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import createHistory from 'history/createBrowserHistory';
// 'routerMiddleware': the new way of storing route changes with redux middleware since rrV4.
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { requestsPromiseMiddleware } from 'redux-saga-requests';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers';

export const history = createHistory();
const connectRouterHistory = connectRouter(history);

function configureStoreProd(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [
    // Add other middleware on this line...
    requestsPromiseMiddleware({ auto: true }),
    sagaMiddleware,
    reactRouterMiddleware,
  ];

  const store = createStore(
    connectRouterHistory(rootReducer),
    initialState,
    compose(applyMiddleware(...middlewares)),
  );

  store.runSaga = sagaMiddleware.run;

  return store;
}

function configureStoreDev(initialState) {
  const reactRouterMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [
    // Add other middleware on this line...

    // Redux middleware that spits an error on you when you
    // try to mutate your state either inside a dispatch or between dispatches.
    reduxImmutableStateInvariant({
      ignore: ['pathAnalysis.data', 'dateRange.startDate', 'dateRange.endDate', 'form.cms_upload_file', 'query', 'currentUser', 'pathV2.data', 'reportsQuery', 'reportsQuery.queryResponse'],
    }),
    requestsPromiseMiddleware({ auto: true }),
    sagaMiddleware,
    reactRouterMiddleware,
  ];

  // add support for Redux dev tools
  // eslint-disable-next-line no-underscore-dangle
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const store = createStore(
    connectRouterHistory(rootReducer),
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers').default; // eslint-disable-line global-require
      store.replaceReducer(connectRouterHistory(nextRootReducer));
    });
  }

  store.runSaga = sagaMiddleware.run;

  return store;
}

const configureStore = process.env.NODE_ENV === 'production' ? configureStoreProd : configureStoreDev;

export default configureStore;
